import React from 'react';
import { Grid } from '@mui/material';
import styles from './styles';
import StatisticItem from './StatisticItem';

function Statistic({ statistic = [], justify, variant, noWrapLink }) {
  return (
    <Grid container sx={styles.container}>
      {statistic.map((item) => (
        <Grid
          item
          sx={styles.item}
          key={item.id}
          xs={justify || 6}
          xl={statistic.length > 2 ? 3 : Math.floor(12 / statistic.length)}
        >
          <StatisticItem {...item} variant={variant} noWrapLink={noWrapLink} />
        </Grid>
      ))}
    </Grid>
  );
}

export default Statistic;
